import { VueInReact, ReactInVue } from 'vuera'

// 获取Vue组件
const getVueComponent = VueInReact

// 转换为Vue组件
const convertToVueComponent = ReactInVue

export {
  getVueComponent,
  convertToVueComponent
}
